import { render } from "./stronaKontaHistoriaZamowien.vue?vue&type=template&id=4a9f5dbc&scoped=true"
import script from "./stronaKontaHistoriaZamowien.vue?vue&type=script&lang=js"
export * from "./stronaKontaHistoriaZamowien.vue?vue&type=script&lang=js"

import "./stronaKontaHistoriaZamowien.vue?vue&type=style&index=0&id=4a9f5dbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9f5dbc"]])

export default __exports__